module.exports = __webpack_public_path__ + "static/newGatsby-6458fa4965a76a293f008370284bcaaa.png";